import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Hidden, Input } from '~/components/Form';

import { t } from '~/helpers';
import { GFE } from '~/constants/perfil';

import { Container } from './styles';

import { updateOperacaoVeiculoManutencaoUnidata } from '~/store/modules/operacaoveiculomanutencaounidata/actions';
import { toast } from 'react-toastify';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { loading, find, params } = useSelector(
    (state) => state.operacaoveiculomanutencaounidata
  );

  const { profile } = useSelector((state) => state.user);

  const initials = create ? data : { ...find, ...data };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GFE) {
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  async function handleSubmit(param) {
    if (profile.glousuariotipo === GFE) {
      toast.error('Usuário não tem permissão para alteração');
      return;
    }
    // if (reference.current.getFieldValue('veic_em_afericao') === 'S') {
    //   toast.error('Veículo já está em aferição');
    //   return;
    // }
    // if (
    //   reference.current.getFieldValue('vedv_contador_permite') !== 'PERMITE'
    // ) {
    //   toast.error('Usuário não tem permissão para alteração');
    //   return;
    // }

    let op = param.veic_em_manutencao === 'N' ? 'MUI' : 'MUR';

    try {
      const schema = Yup.object().shape({
        veic_placa: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        orga_codigo: param.orga_codigo,
        unid_codigo: param.unid_codigo,
        veic_placa: param.veic_placa,
        veic_em_manutencao: param.veic_em_manutencao,
        veic_em_afericao: param.veic_em_afericao,
        acao: "M",
        tipo: op,
        habilitaRecall: 'false',
        motivo: ''
      };

      await dispatch(updateOperacaoVeiculoManutencaoUnidata(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <Container>
      <>
        {loading ? (
          <div style={{ height: '14rem', width: '50rem' }}>
            <Spinner loading />
          </div>
        ) : (
            <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
              <Hidden name="orga_codigo" />
              <Hidden name="unid_codigo" />
              <Hidden name="veic_em_manutencao" />
              <Hidden name="veic_em_afericao" />

              <div style={{ margin: '2rem' }}>
                {(initials.veic_em_manutencao === 'N') ? <h3>Incluir em Manutenção</h3> : <h3>Retirar da Manutenção</h3>}
              </div>

              <Input name="veic_placa" label="Veículo" disabled="true" />
            </Form>
          )}
      </>
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
